import React from 'react';
import { ReactComponent as IconRestricted } from '../../images/icon-restricted.svg';
import { useTranslation } from '../../i18n/useTranslation';

interface Props {
    title: string;
    description?: string;
    className?: string;
}

export const AccessRestrictedBlock = ({ title, description, className }: Props) => {
    const { t } = useTranslation();

    return (
        <div
            className={`c-access-restricted-block fill-height f-border-all f-rounded-corner-1 overflow-hidden ${
                className ? ` ${className}` : ''
            }`}
        >
            <div className="c-access-restricted-block__header f-border-bottom">
                <span className="f-text-big-content f-text-semibold f-color-dark-black-s100">{title}</span>
            </div>
            <div className="c-access-restricted-block__body">
                <IconRestricted
                    role="img"
                    aria-label={t('Access Restricted')}
                    className="f-size-icon-md f-color-dark-black-s100"
                />
                <div className="f-text-big-content f-text-semibold f-color-dark-black-s100">
                    {t('Access Restricted')}
                </div>
                <div className="f-text-medium-content f-color-dark-black-s70">
                    {description || (
                        <>
                            <span>{t('ACCESS_RESTRICTED_TITLE')}</span>
                            <br />
                            <span>{t('ACCESS_RESTRICTED_SUB')}</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
